// extracted by mini-css-extract-plugin
export default {"input":"src-components-ExpandInput-css__input--Ni917"};